import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllStarred: {
		defaultMessage: 'View all starred',
		id: 'atlassian-navigation.common.menu.view-all.view-all-starred',
		description: 'Link to view all starred items.',
	},
});
